// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__TylP3","card":"style_card__w0GKy"};